export const Heading = {
  baseStyle: {
    color: '#000;',
    fontStyle: 'normal',
    fontWeight: '700',
  },
  sizes: {
    h1: {
      fontSize: '40px',
      lineHeight: '40px',
    },
    h2: {
      fontSize: '32px',
      lineHeight: '32px',
    },
    h3: {
      fontSize: '24px',
      lineHeight: '24px',
    },
    h4: {
      fontSize: '20px',
      lineHeight: '20px',
    },
    h5: {
      fontSize: '18px',
      lineHeight: '24px',
    },
    h6: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
}
